/** @jsxImportSource @emotion/react */


import { Fragment, useCallback, useContext } from "react"
import { Badge as RadixThemesBadge, Button as RadixThemesButton, Card as RadixThemesCard, Code as RadixThemesCode, Container as RadixThemesContainer, Flex as RadixThemesFlex, Heading as RadixThemesHeading, Inset as RadixThemesInset, Link as RadixThemesLink, Tabs as RadixThemesTabs, Text as RadixThemesText } from "@radix-ui/themes"
import { Iconbutton_98348b16bede352a0d51b6c9200c6e68, Select__root_9891502375e64bdca86a76873639e4de } from "$/utils/stateful_components"
import NextLink from "next/link"
import { Code as LucideCode, Eye as LucideEye } from "lucide-react"
import { ColorModeContext, EventLoopContext, StateContexts } from "$/utils/context"
import { Event, refs } from "$/utils/state"
import dynamic from "next/dynamic"
import "leaflet/dist/leaflet.css"
import { PrismAsyncLight as SyntaxHighlighter } from "react-syntax-highlighter"
import oneLight from "react-syntax-highlighter/dist/cjs/styles/prism/one-light"
import oneDark from "react-syntax-highlighter/dist/cjs/styles/prism/one-dark"
import NextHead from "next/head"
import { jsx } from "@emotion/react"

const Tooltip = dynamic(() => import('react-leaflet').then((mod) => mod.Tooltip), { ssr: false });
const Circle = dynamic(() => import('react-leaflet').then((mod) => mod.Circle), { ssr: false });
const Rectangle = dynamic(() => import('react-leaflet').then((mod) => mod.Rectangle), { ssr: false });
const MapContainer = dynamic(() => import('$/public/external/reflex_enterprise/components/map/base/MapLazyComponents.js').then((mod) => mod.MapContainer), { ssr: false });
const TileLayer = dynamic(() => import('react-leaflet').then((mod) => mod.TileLayer), { ssr: false });
const Marker = dynamic(() => import('react-leaflet').then((mod) => mod.Marker), { ssr: false });
const Polyline = dynamic(() => import('react-leaflet').then((mod) => mod.Polyline), { ssr: false });
const MapConsumer = dynamic(() => import('$/public/external/reflex_enterprise/components/map/base/MapLazyComponents.js').then((mod) => mod.MapConsumer), { ssr: false });
const CircleMarker = dynamic(() => import('react-leaflet').then((mod) => mod.CircleMarker), { ssr: false });
const Polygon = dynamic(() => import('react-leaflet').then((mod) => mod.Polygon), { ssr: false });


export function Button_e0e2e9fcc472e2fbe3188c8831a2b187 () {
  
  const [addEvents, connectErrors] = useContext(EventLoopContext);


  const on_click_bd50b4c13c343289a47419db30f07bfe = useCallback(((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (refs['vector-layers-demo']["getBounds"]())), ["callback"] : "(_result) => {queueEvents([Event(\"_call_function\", {function:(() => (console[\"log\"](_result))),callback:null})], socket); processEvent(socket)}" }), ({  })))], args, ({  })))), [addEvents, Event])



  
  return (
    jsx(
RadixThemesButton,
{onClick:on_click_bd50b4c13c343289a47419db30f07bfe},
"Get Bounds"
,)
  )
}

export function Mapcontainer_b83f6ca6c9343c676c7574649e6db4fe () {
  
  const reflex___state____state__map___vector_layers____vector_layers_state = useContext(StateContexts.reflex___state____state__map___vector_layers____vector_layers_state)





  
  return (
    jsx(
MapContainer,
{center:reflex___state____state__map___vector_layers____vector_layers_state.center,css:({ ["width"] : "100%", ["height"] : "50vh" }),zoom:reflex___state____state__map___vector_layers____vector_layers_state.zoom},
jsx(TileLayer,{url:"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"},)
,jsx(Circle,{center:({ ["lat"] : 51.505, ["lng"] : -0.09 }),pathOptions:({ ["color"] : "#ff0000", ["fillColor"] : "#ff3333", ["fillOpacity"] : 0.5 }),radius:500},)
,jsx(
CircleMarker,
{center:({ ["lat"] : 51.515, ["lng"] : -0.09 }),pathOptions:({ ["color"] : "#ff0000", ["fillColor"] : "#ff3333", ["fillOpacity"] : 0.5 }),radius:15},
jsx(
Tooltip,
{},
"Circle Marker A"
,),),jsx(Polygon,{pathOptions:({ ["color"] : "#0033ff", ["weight"] : 2, ["fillColor"] : "#3366ff", ["fillOpacity"] : 0.4 }),positions:[({ ["lat"] : 51.51, ["lng"] : -0.1 }), ({ ["lat"] : 51.51, ["lng"] : -0.08 }), ({ ["lat"] : 51.5, ["lng"] : -0.07 }), ({ ["lat"] : 51.49, ["lng"] : -0.08 }), ({ ["lat"] : 51.49, ["lng"] : -0.1 })]},)
,jsx(Polyline,{pathOptions:({ ["color"] : "#166516FF", ["weight"] : 5, ["opacity"] : 0.7, ["lineCap"] : "round", ["dashArray"] : "5,10" }),positions:[({ ["lat"] : 51.52, ["lng"] : -0.12 }), ({ ["lat"] : 51.53, ["lng"] : -0.11 }), ({ ["lat"] : 51.51, ["lng"] : -0.06 }), ({ ["lat"] : 51.52, ["lng"] : -0.05 })]},)
,jsx(Rectangle,{bounds:[[51.49, -0.13], [51.51, -0.11]],pathOptions:({ ["color"] : "#ff9900", ["weight"] : 3, ["fillColor"] : "#ffcc00", ["fillOpacity"] : 0.3 })},)
,jsx(
Marker,
{position:({ ["lat"] : 51.505, ["lng"] : -0.09 })},
jsx(
Tooltip,
{},
"Center point"
,),),jsx(MapConsumer,{eventsHandler:({  }),mapRef:"vector-layers-demo"},)
,)
  )
}

export function Prismasynclight_5953d31587e8b0114d3c5250a3e61ac5 () {
  
  const { resolvedColorMode } = useContext(ColorModeContext)

  
if ("python") {
    
(async () => {
    try {
        const module = await import(`react-syntax-highlighter/dist/cjs/languages/prism/${"python"}`);
        SyntaxHighlighter.registerLanguage("python", module.default);
    } catch (error) {
        console.error(`Language ${"python"} is not supported for code blocks inside of markdown: `, error);
    }
})();

}




  
  return (
    jsx(SyntaxHighlighter,{children:"\"\"\"Map demo showcasing vector layers.\"\"\"\n\nimport reflex as rx\n\nimport reflex_enterprise as rxe\nfrom reflex_enterprise.components.map.types import LatLng, latlng, latlng_bounds\n\nfrom .common import demo\n\n\nclass VectorLayersState(rx.State):\n    \"\"\"State class for the vector layers map demo.\"\"\"\n\n    # Define state variables\n    zoom: float = 13\n    center: LatLng = latlng(lat=51.505, lng=-0.09)\n\n\n@demo(\n    route=\"/vector-layers\",\n    title=\"Vector Layers\",\n    description=\"Demonstrates different vector layers like circles, polygons, polylines, and rectangles.\",\n)\ndef vector_layers() -> rx.Component:\n    # Create coordinates for our vector layers\n    center = latlng(lat=51.505, lng=-0.09)\n    map_id = \"vector-layers-demo\"\n\n    # Create polygon coordinates\n    polygon_points = [\n        latlng(lat=51.51, lng=-0.1),\n        latlng(lat=51.51, lng=-0.08),\n        latlng(lat=51.5, lng=-0.07),\n        latlng(lat=51.49, lng=-0.08),\n        latlng(lat=51.49, lng=-0.1),\n    ]\n\n    # Create polyline coordinates\n    polyline_points = [\n        latlng(lat=51.52, lng=-0.12),\n        latlng(lat=51.53, lng=-0.11),\n        latlng(lat=51.51, lng=-0.06),\n        latlng(lat=51.52, lng=-0.05),\n    ]\n\n    # Create rectangle bounds\n    rect_bounds = latlng_bounds(\n        corner1_lat=51.49,  # Southwest corner\n        corner1_lng=-0.13,\n        corner2_lat=51.51,  # Northeast corner\n        corner2_lng=-0.11,\n    )\n\n    # Create path options for styling\n    circle_options = rxe.map.path_options(\n        color=\"#ff0000\",\n        fill_color=\"#ff3333\",\n        fill_opacity=0.5,\n    )\n\n    polygon_options = rxe.map.path_options(\n        color=\"#0033ff\",\n        fill_color=\"#3366ff\",\n        fill_opacity=0.4,\n        weight=2,\n    )\n\n    polyline_options = rxe.map.path_options(\n        color=\"#166516FF\",\n        weight=5,\n        opacity=0.7,\n        line_cap=\"round\",\n        dash_array=\"5,10\",\n    )\n\n    rectangle_options = rxe.map.path_options(\n        color=\"#ff9900\",\n        fill_color=\"#ffcc00\",\n        fill_opacity=0.3,\n        weight=3,\n    )\n\n    return rx.vstack(\n        rx.heading(\"Vector Layers Demo\"),\n        rx.text(\"This map demonstrates different vector layers available in Leaflet.\"),\n        rx.button(\n            \"Get Bounds\",\n            on_click=rxe.map.api(map_id).get_bounds(\n                callback=rx.console_log,\n            ),\n        ),\n        rxe.map(\n            # Base tile layer\n            rxe.map.tile_layer(\n                url=\"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png\",\n            ),\n            # Add Circle\n            rxe.map.circle(\n                center=center,\n                radius=500,  # 500 meters\n                path_options=circle_options,\n            ),\n            # Add CircleMarker (radius in pixels)\n            rxe.map.circle_marker(\n                rxe.map.tooltip(\"Circle Marker A\"),\n                center=latlng(lat=51.515, lng=-0.09),\n                radius=15,  # 15 pixels\n                path_options=circle_options,\n            ),\n            # Add Polygon\n            rxe.map.polygon(\n                positions=polygon_points,\n                path_options=polygon_options,\n            ),\n            # Add Polyline\n            rxe.map.polyline(\n                positions=polyline_points,\n                path_options=polyline_options,\n            ),\n            # Add Rectangle\n            rxe.map.rectangle(\n                bounds=rect_bounds,\n                path_options=rectangle_options,\n            ),\n            # Add markers to help with orientation\n            rxe.map.marker(\n                rxe.map.tooltip(\"Center point\"),\n                position=latlng(lat=51.505, lng=-0.09),\n            ),\n            # Map settings\n            id=map_id,\n            zoom=VectorLayersState.zoom,\n            center=VectorLayersState.center,\n            width=\"100%\",\n            height=\"50vh\",\n        ),\n        rx.text(\n            \"The map shows: a red circle (500m radius), a red circle marker (15px), a blue polygon, \"\n            \"a green dashed polyline, and an orange rectangle.\"\n        ),\n        width=\"100%\",\n        padding=\"1em\",\n    )\n",language:"python",showLineNumbers:true,style:((resolvedColorMode === "light") ? oneLight : oneDark)},)

  )
}

export default function Component() {
    




  return (
    jsx(
Fragment,
{},
jsx(
RadixThemesContainer,
{css:({ ["padding"] : "16px" }),size:"4"},
jsx(
RadixThemesFlex,
{align:"center",className:"rx-Stack",css:({ ["width"] : "100%" }),direction:"row",gap:"3"},
jsx(Select__root_9891502375e64bdca86a76873639e4de,{},)
,jsx(RadixThemesFlex,{css:({ ["flex"] : 1, ["justifySelf"] : "stretch", ["alignSelf"] : "stretch" })},)
,jsx(
RadixThemesLink,
{asChild:true,css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) })},
jsx(
NextLink,
{href:"/",passHref:true},
jsx(
RadixThemesHeading,
{size:"4"},
"Map Demos"
,),),),jsx(Iconbutton_98348b16bede352a0d51b6c9200c6e68,{},)
,),jsx(
RadixThemesText,
{as:"p",css:({ ["marginLeft"] : "10px", ["marginTop"] : "5px" })},
"Demonstrates different vector layers like circles, polygons, polylines, and rectangles."
,),jsx(
RadixThemesTabs.Root,
{css:({ ["&[data-orientation='vertical']"] : ({ ["display"] : "flex" }), ["marginTop"] : "1em" }),defaultValue:"example"},
jsx(
RadixThemesTabs.List,
{css:({ ["&[data-orientation='vertical']"] : ({ ["display"] : "block", ["boxShadow"] : "inset -1px 0 0 0 var(--gray-a5)" }), ["marginBottom"] : "1em" })},
jsx(
RadixThemesTabs.Trigger,
{css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%" }) }),value:"example"},
jsx(
RadixThemesFlex,
{align:"start",className:"rx-Stack",direction:"row",gap:"3"},
jsx(LucideEye,{},)
,jsx(
RadixThemesText,
{as:"p"},
"Example"
,),),),jsx(
RadixThemesTabs.Trigger,
{css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%" }) }),value:"source"},
jsx(
RadixThemesFlex,
{align:"start",className:"rx-Stack",direction:"row",gap:"3"},
jsx(LucideCode,{},)
,jsx(
RadixThemesText,
{as:"p"},
"Source"
,),),),),jsx(
RadixThemesTabs.Content,
{css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%", ["margin"] : null }), ["height"] : "fit-content" }),value:"example"},
jsx(
RadixThemesFlex,
{align:"start",className:"rx-Stack",css:({ ["width"] : "100%", ["padding"] : "1em" }),direction:"column",gap:"3"},
jsx(
RadixThemesHeading,
{},
"Vector Layers Demo"
,),jsx(
RadixThemesText,
{as:"p"},
"This map demonstrates different vector layers available in Leaflet."
,),jsx(Button_e0e2e9fcc472e2fbe3188c8831a2b187,{},)
,jsx(Mapcontainer_b83f6ca6c9343c676c7574649e6db4fe,{},)
,jsx(
RadixThemesText,
{as:"p"},
"The map shows: a red circle (500m radius), a red circle marker (15px), a blue polygon, a green dashed polyline, and an orange rectangle."
,),),),jsx(
RadixThemesTabs.Content,
{css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%", ["margin"] : null }) }),value:"source"},
jsx(
RadixThemesCard,
{},
jsx(
RadixThemesInset,
{pb:"current",side:"top"},
jsx(
RadixThemesBadge,
{css:({ ["width"] : "100%", ["height"] : "3em" }),radius:"none",size:"2"},
jsx(
RadixThemesCode,
{},
"demos/map/map/vector_layers.py"
,),),),jsx(Prismasynclight_5953d31587e8b0114d3c5250a3e61ac5,{},)
,),),),),jsx(
NextHead,
{},
jsx(
"title",
{},
"Vector Layers"
,),jsx("meta",{content:"Demonstrates different vector layers like circles, polygons, polylines, and rectangles.",name:"description"},)
,jsx("meta",{content:"favicon.ico",property:"og:image"},)
,),)
  )
}
